import { LitElement, html, svg } from 'lit';

export class IconBank24 extends LitElement {
  render() { return html`<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><title>En bank med tre søyler</title><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="m12 1 11 5H1l11-5ZM1 23h22"></path><path stroke="currentColor" stroke-linejoin="round" stroke-width="1.5" d="M2 20V9h4v11H2ZM18 20V9h4v11h-4ZM10 20V9h4v11h-4Z"></path></svg>`; }
}
if (!customElements.get('f-icon-bank24', IconBank24)) {
  customElements.define('f-icon-bank24', IconBank24);
}